import dayjs from 'dayjs'
import { downFile } from '@/api/common'
import { BigNumber } from 'bignumber.js'

export function detectIE() {
  const ua = window.navigator.userAgent

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  const msie = ua.indexOf('MSIE')
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  const trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  const edge = ua.indexOf('Edge/')
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }

  // other browser
  return false
}

export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r !== null) return unescape(r[2])
  return null
}

export function exportBlobDataToFile(blobData, fileName) {
  // 创建一个a标签
  const link = document.createElement('a')
  // 创建一个Blob URL，并将其赋值给a标签的href属性
  link.href = window.URL.createObjectURL(blobData)
  // 设置下载文件的名称
  link.download = fileName
  // 模拟点击a标签进行下载
  link.click()
  // 释放Blob URL资源
  window.URL.revokeObjectURL(link.href)
}

export function downloadExcel(url) {
  downFile(url).then(({ data, headers }) => {
    const blob = new Blob([data])
    const fileName = decodeURIComponent(headers['content-disposition'].split(';')[1].split('=')[1])
    exportBlobDataToFile(blob, fileName)
  })
}

export function dateFormat() {
  // eslint-disable-next-line no-extend-native
  Date.prototype.Format = function (fmt) {
    const o = {
      'M+': this.getMonth() + 1, // 月份
      'd+': this.getDate(), // 日
      'H+': this.getHours(), // 小时
      'm+': this.getMinutes(), // 分
      's+': this.getSeconds(), // 秒
      'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
      S: this.getMilliseconds() // 毫秒
    }
    // eslint-disable-next-line no-param-reassign
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, String(this.getFullYear()).substr(4 - RegExp.$1.length))
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt))
        // eslint-disable-next-line no-param-reassign
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length))
    }
    return fmt
  }
}
// pamm 买入确认时间
export function calcConfirmTime(freezeTime, adjustTime) {
  const arr = adjustTime.split(':')
  let t0 = arr[0]
  let t1 = arr[1]
  if (Number(t1) > 0) {
    if (Number(t1) >= Number(freezeTime)) {
      t1 = Number(t1) - Number(freezeTime)
      if (t1 <= 9) {
        t1 = '0' + t1
      }
      return `${t0}:${t1}`
    } else {
      t0 = t0 - 1
      t1 = t1 + 60 - Number(freezeTime)
      if (t1 <= 9) {
        t1 = '0' + t1
      }
      if (t0 <= 9) {
        t0 = '0' + t0
      }
      return `${t0}:${t1}`
    }
  } else {
    t0 = t0 - 1
    t1 = 60 - Number(freezeTime)
    if (t1 <= 9) {
      t1 = '0' + t1
    }
    if (t0 <= 9) {
      t0 = '0' + t0
    }
    return `${t0}:${t1}`
  }
}
// 计算红涨绿跌
export function calcRedProgressOrGreenLossCls(colorPreference, value) {
  if (Number(colorPreference) === 1) {
    if (Number(value) >= 0) {
      return 'red'
    } else {
      return 'green'
    }
  } else {
    if (Number(value) >= 0) {
      return 'green'
    } else {
      return 'red'
    }
  }
}
// 计算红涨绿跌
export function calcRedProgressOrGreenLossColor(colorPreference, value) {
  if (Number(colorPreference) === 1) {
    if (Number(value) >= 0) {
      return '#EE6D4B'
    } else {
      return '#3CC865'
    }
  } else {
    if (Number(value) >= 0) {
      return '#3CC865'
    } else {
      return '#EE6D4B'
    }
  }
}
// 自动隐藏echart tooltip
export function autoHideEchartTooltip(myChart) {
  document.getElementById('crm').addEventListener('scroll', () => {
    myChart.dispatchAction({
      type: 'hideTip'
    })
  })
}
// 获取本地时区
export function getLocalTimezoneGMT() {
  const now = new Date()
  const timezoneOffset = now.getTimezoneOffset()
  const gmtOffset = timezoneOffset
  return gmtOffset
}

// 获取服务器时区时间
export function getServerGmtDatetime(serverTimezone, formatDateTime) {
  const regex = new RegExp(/([0-9]{2}):([0-9]{2})/)
  regex.test(serverTimezone)
  let minutes = Number(RegExp.$1) * 60 + Number(RegExp.$2)
  let offsetMinutes = 0
  const localGmt = getLocalTimezoneGMT()
  const current = new Date()
  if (serverTimezone.indexOf('+')) {
    minutes = -minutes
  } else {
    minutes = Number(minutes)
  }
  if (minutes > localGmt) {
    offsetMinutes = Math.abs(minutes - localGmt)
    current.setMinutes(current.getMinutes() + offsetMinutes)
  } else {
    offsetMinutes = Math.abs(localGmt - minutes)
    current.setMinutes(current.getMinutes() - offsetMinutes)
  }
  const dt = dayjs(current).format(formatDateTime)
  return dt
}

// 区号去掉前缀+
export function clearAreaCodePrefix(mzone) {
  if (mzone) {
    return mzone?.replace('+', '')
  } else {
    return ''
  }
}

export function isJSON(str) {
  if (typeof str === 'string') {
    try {
      if (str.indexOf('{') > -1) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}

export function alarm() {
  try {
    const audio = new Audio()
    audio.src = require('@/assets/audio/msg.mp3')
    audio.play()
  } catch (e) {
    console.error(e)
  }
}

export function truncateNumber(num, index) {
  // 将数字转换为字符串，处理可能的小数部分
  const numStr = String(num)
  // 查找小数点的位置
  const dotIndex = numStr.indexOf('.')
  // 如果没有小数点或不需要截断，则直接返回原数字
  if (dotIndex === -1) {
    if (index === 0) {
      // 如果数据没有小数点 而且精度为0时
      return numberFormatter(num)
    } else {
      // 补0
      const value = num + '.' + '0'.repeat(index)
      return numberFormatter(value)
    }
  }
  // 获取小数点前
  const integerPart = numStr.substring(0, dotIndex)
  if (index === 0) {
    // 数据有小数点 而且精度为0时
    return numberFormatter(integerPart)
  }
  // 获取小数点后
  let decimalPart = numStr.substring(dotIndex + 1)
  // padEnd 如果截断不够自动填充不全
  decimalPart = decimalPart.substring(0, index).padEnd(index, '0')
  return numberFormatter(`${integerPart}.${decimalPart}`)
}

// 设置千分位格式
export function numberFormatter(value, dp = null) {
  let number = new BigNumber(value)
  if (number.isNaN()) {
    number = new BigNumber(0)
  }
  const fmt = {
    prefix: '',
    decimalSeparator: '.',
    groupSeparator: ',',
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: ' ',
    fractionGroupSize: 0,
    suffix: ''
  }
  // return Number(_value).toLocaleString()
  // return _value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return number.toFormat(dp, BigNumber.ROUND_DOWN, fmt)
}

export function handletruncation(value, dp = null) {
  let number = new BigNumber(value)
  if (number.isNaN()) {
    number = new BigNumber(0)
  }

  // return Number(_value).toLocaleString()
  // return _value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return number.toFixed(dp, BigNumber.ROUND_DOWN)
}

// add this function to replace either(isEmpty, isNil)(x), which is from ramda
export function isEmpty(x) {
  return (
    x === null ||
    x === undefined ||
    (typeof x === 'object' && Object.keys(x).length === 0) ||
    (Array.isArray(x) && x.length === 0) ||
    (typeof x === 'string' && x.trim().length === 0)
  )
}
